module.exports = __webpack_public_path__ + "img/admission-7.35e8822d.jpg";